import { render, staticRenderFns } from "./TransferDeleteModal.vue?vue&type=template&id=2fdb5642&scoped=true&"
import script from "./TransferDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./TransferDeleteModal.vue?vue&type=script&lang=ts&"
import style0 from "./TransferDeleteModal.vue?vue&type=style&index=0&id=2fdb5642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdb5642",
  null
  
)

export default component.exports